module.exports = __webpack_public_path__ + "static/vorschlag-76cde6ff48c34fed38cb4e91fcf5919e.jpg";